import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { NotifierService } from 'angular-notifier';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { OrderPaymentComponent } from '../../../outbound/components/modals/order-payment/order-payment.component';
import { AttachInvoiceModalComponent } from '../modals/attach-invoice-modal/attach-invoice-modal.component';
import { OrderDetailsModalComponent } from '../modals/order-details-modal/order-details-modal.component';
import { UpdateOrderComponent } from 'src/app/shared/modals/update-order/update-order.component';
import { OrderPaymentInboundComponent } from '../../../inbound/components/modals/order-payment-inbound/order-payment-inbound.component';
import { BoobleModalService } from 'booble-modal';
import { BankChannelModalComponent } from '../modals/bank-channel-modal/bank-channel-modal.component';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { QuotationModalComponent } from '../modals/quotation-modal/quotation-modal.component';
import { catchError, forkJoin, map, of } from 'rxjs';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { QuotationModalMobileComponent } from '../modals/quotation-modal/quotation-modal-mobile/quotation-modal-mobile.component';
import { GenericBottomSheetComponent } from 'src/app/shared/components/generic-bottom-sheet/generic-bottom-sheet.component';
import { SelectBankAccountComponent } from '../../../inbound/components/modals/select-bank-account/select-bank-account.component';

@Component({
  selector: 'app-orders-mobile',
  templateUrl: './orders-mobile.component.html',
  styleUrls: ['./orders-mobile.component.scss'],
})
export class OrdersMobileComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() data: InboundOrderDto[];
  @Input() warrenGlobalOnly?: boolean;

  moedas = Moedas;
  private readonly notifier: NotifierService;

  pageIndex = 1;
  translations = {
    AVAILABLE_QUOTATION: 'Aguardando cotação',
    IDENTIFYING_PAYMENT_ABROAD: 'Aguardando pagamento no exterior',
    IDENTIFIED_PAYMENT_ABROAD: 'Pendente informações',
    REPROVED_WITH_CORRECTION: 'Reprovada',
    AVAILABLE_PAYMENT: 'Fechamento concluído',
    CANCELED: 'Cancelada',
    PENDING_LIQUIDATION: 'Fechamento concluído',
    IDENTIFYING_PAYMENT: 'Identificando pagamento',
    IDENTIFIED_PAYMENT: 'Pagamento identificado',
    PAID: 'Liquidada',
    PROCESSING: 'Em análise',
  };
  searchTerm: string = '';
  filteredItems: any;
  isMobile: boolean;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('bottomSheetContent') bottomSheetContent: TemplateRef<any>;
  @ViewChild('bottomSheetContentPayment')
  bottomSheetContentPayment: TemplateRef<any>;

  @ViewChild('bottomSheetContentBankAccount')
  bottomSheetContentBankAccount: TemplateRef<any>;

  @ViewChild('bottomSheetContentUpdateOrder')
  bottomSheetContentUpdateOrder: TemplateRef<any>;

  pageSizeOptions = [3, 5, 10, 15, 25, 50];
  pageSize = 3;
  currentPage = 0;

  constructor(
    private modalService: BoobleModalService,
    private ordersService: OrdersService,
    private bottomSheet: MatBottomSheet,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 820;
    this.filteredItems = this.data;
    this.applyFilter();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue) {
      this.filteredItems = changes.data.currentValue;
      this.applyFilter();
    }
  }

  ngAfterViewInit() {
    this.paginator.page.subscribe(() => {
      this.currentPage = this.paginator.pageIndex;
    });
  }

  changePage(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
  }

  async downloadAttachment(order: any) {
    const downloadTasks = [];

    if (order.orderSettlement.exchangeContractFile) {
      downloadTasks.push({
        fileName: order.orderSettlement.exchangeContractFile,
        promise: this.ordersService
          .downloadOrderAttachmentByName(
            order.orderSettlement.exchangeContractFile
          )
          .toPromise(),
      });
    }

    if (order.orderSettlement.proofOperationFile) {
      downloadTasks.push({
        fileName: order.orderSettlement.proofOperationFile,
        promise: this.ordersService
          .downloadOrderAttachmentByName(
            order.orderSettlement.proofOperationFile
          )
          .toPromise(),
      });
    }

    const results = await Promise.allSettled(
      downloadTasks.map((task) => task.promise)
    );

    let allSuccessful = true;

    results.forEach((result, index) => {
      const task = downloadTasks[index];
      if (result.status === 'fulfilled') {
        this.ordersService.downloadAttachmentMobile(
          result.value,
          task.fileName
        );
      } else {
        allSuccessful = false;
      }
    });

    if (allSuccessful) {
      this.notifier.notify('success', 'Download realizado com sucesso!');
    } else {
      this.notifier.notify(
        'error',
        'O download de um ou mais documentos falhou.'
      );
    }
  }

  applyFilter() {
    const searchTermLower = this.searchTerm.toLowerCase();

    this.filteredItems = this.data.filter((item: InboundOrderDto) => {
      const statusFlowInEnglish = (
        this.translations[item.statusFlow] || item.statusFlow
      ).toLowerCase();
      const currency = (item.currency.description || '').toLowerCase();
      const orderId = item.id.toString().toLowerCase();
      const amount = item.amount.toString().toLowerCase();

      return (
        statusFlowInEnglish.indexOf(searchTermLower) !== -1 ||
        currency.indexOf(searchTermLower) !== -1 ||
        orderId.indexOf(searchTermLower) !== -1 ||
        amount.indexOf(searchTermLower) !== -1
      );
    });
    //this.sortItemsById();
  }

  /*   sortItemsById() {
    this.filteredItems.sort(
      (a: InboundOrderDto, b: InboundOrderDto) => b.id - a.id
    );
  } */

  get totalPages(): number {
    return Math.ceil(this.filteredItems.length / this.pageSize);
  }

  get displayedItems(): any[] {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return this.filteredItems.slice(startIndex, endIndex);
  }

  openQuotationModal(order: InboundOrderDto) {
    if (!this.isMobile) {
      const data = {
        order: order,
        orderType: order.remmitanceType === 'OUTBOUND' ? 1 : 0,
        finality: order.finality,
        amount: order.amount,
        country:
          order.remmitanceType === 'OUTBOUND'
            ? order.receiver.country
            : order.sender.country,
        orderId: order.id,
        currency: this.moedas.find((moeda) => moeda.id === order.currency.id),
      };
      this.modalService.present(QuotationModalComponent, data);
    } else {
      const bottomSheetConfig = {
        data: {
          order: order,
          orderType: order.remmitanceType === 'OUTBOUND' ? 1 : 0,
          finality: order.finality,
          amount: order.amount,
          country:
            order.remmitanceType === 'OUTBOUND'
              ? order.receiver.country
              : order.sender.country,
          orderId: order.id,
          currency: this.moedas.find((moeda) => moeda.id === order.currency.id),
        },
      };
      this.bottomSheet.open(QuotationModalMobileComponent, bottomSheetConfig);
    }
  }

  openOrderPaymentModal(order: InboundOrderDto) {
    if (this.isMobile) {
      this.openBottomSheet();
    } else {
      this.modalService.present(OrderPaymentComponent, order);
    }
  }

  openBottomSheet() {
    this.bottomSheet.open(GenericBottomSheetComponent, {
      data: { content: this.bottomSheetContent },
    });
  }

  openBottomSheetBankAccount() {
    this.bottomSheet.open(GenericBottomSheetComponent, {
      data: { content: this.bottomSheetContentBankAccount },
    });
  }

  openBottomSheetPayment() {
    this.bottomSheet.open(GenericBottomSheetComponent, {
      data: { content: this.bottomSheetContentPayment },
    });
  }

  openBottomSheetUpdateOrder() {
    this.bottomSheet.open(GenericBottomSheetComponent, {
      data: { content: this.bottomSheetContentUpdateOrder },
    });
  }

  openAttachInvoiceModal(order: InboundOrderDto) {
    this.modalService.present(AttachInvoiceModalComponent, order);
  }

  openOrderDetailsModal(order: InboundOrderDto) {
    this.modalService.present(OrderDetailsModalComponent, order);
  }

  openUpdateOrderModal(order: InboundOrderDto) {
    if (this.isMobile) {
      this.openBottomSheetUpdateOrder();
    } else {
      this.modalService.present(UpdateOrderComponent, order);
    }
  }

  openPaymentInboundModal(order: InboundOrderDto) {
    if (this.isMobile) {
      this.openBottomSheetBankAccount();
    } else {
      this.modalService.present(SelectBankAccountComponent, order);
    }
  }

  openSelectBankAccount(order: InboundOrderDto) {
    if (this.isMobile) {
      this.openBottomSheetBankAccount();
    } else {
      this.modalService.present(SelectBankAccountComponent, order);
    }
  }

  openBankChannelModal(currencyDescription: string) {
    this.modalService.present(BankChannelModalComponent, currencyDescription);
  }
}
